import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";

export class RateQuestionPreviewComponent {

    protected sessionService:ISessionService;

    question:IQuestion;
    value:number;

    max = 5;

    private previousValue:number;

    static $inject = ['$scope', 'SharedQuestionService', 'SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    $onInit() {
        if (this.question.meta.scale && isFinite(this.question.meta.scale.to)) {
            this.max = this.question.meta.scale.to;
        }

        let defaultValue = this.question.meta.default;
        if (defaultValue) {
            this.value = parseInt(defaultValue);
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            this.value = answer.values[0].value;
        }
    }

}

app.component('rateQuestionPreview', {
    templateUrl: 'templates/components/questionPreviews/rateQuestionPreview.html',
    controller: RateQuestionPreviewComponent,
    controllerAs: 'rateQuestionPreview',
    bindings: {
        question: '<',
    }
});